
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import {mapState,mapMutations} from 'vuex'
export default {
components: {
Tabbar,
TabbarItem
},
data(){
return{
page:0
}
},
computed:{
...mapState(['token'])
},
created(){
this.SETTOKEN();
this.InitUrl()
},
methods:{
...mapMutations(['SETTOKEN']),
selectedTab(index) {
this.page = index;
},
InitUrl(){
console.log(this.$route.path);
if(this.$route.path.indexOf("index")>0){
this.page=0;
}else if(this.$route.path.indexOf("quotes")>0){
this.page=1;
}else if(this.$route.path.indexOf("funds")>0){
this.page=4;
}else if(this.$route.path.indexOf("trade")>0){
this.page=3;
}else if(this.$route.path.indexOf("news")>0){
this.page=5;
}else if(this.$route.path.indexOf("my")>0){
this.page=6;
}
},
},
watch: {
'$route':'InitUrl'
},
}



// WEBPACK FOOTER //
// ./src/pages/home.vue